import { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/apiClient';

export function usePost(idUser, idPost) {
    const [post, setPost] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const fetchPost = async () => {
            try {
                setLoading(true);
                setError(null);

                const url = new URL('/api/post', process.env.REACT_APP_API_URL);
                url.searchParams.append('idUser', idUser);
                url.searchParams.append('idPost', idPost);

                const response = await apiFetch(url.toString(), {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();

                // Гостя на /auth не уводим: недоступная запись — это ошибка
                // страницы (её показывает ServerError), а не требование входа.
                if (data.status === 'notFound') {
                    throw new Error('Запись не найдена');
                }

                if (!response.ok) {
                    throw new Error('Ошибка сервера');
                }

                if (isMounted) {
                    if (data.error) {
                        throw new Error(data.error);
                    }
                    setPost(data.post);
                    setUser(data.user);
                }
            } catch (err) {
                if (isMounted) {
                    setError(err.message);
                }
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchPost();

        return () => {
            isMounted = false;
        };
    }, [idUser, idPost]);

    return { post, user, loading, error };
}
